import { render } from "./AlertInfo.vue?vue&type=template&id=c6fd77d6"
import script from "./AlertInfo.vue?vue&type=script&lang=js"
export * from "./AlertInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__